import { Icon1C, IconMoySklad } from '@direct-frontend/components';
import { OZON_SERVICE_NAME } from '../brand';
import { INTEGRATION_TYPE_1C, INTEGRATION_TYPE_MOYSKLAD } from './constants';
import { getDisplayTypeFromType } from './getDisplayTypeFromType';
import { type SupportedIntegrationTypes } from './types';

export const WAREHOUSE_HEADER_CAPTIONS: Partial<Record<SupportedIntegrationTypes, string>> = {
    [INTEGRATION_TYPE_1C]: `Ваша основная система ${getDisplayTypeFromType(INTEGRATION_TYPE_1C)}. Чтобы избежать дублирования остатков, укажите для каждого склада ${OZON_SERVICE_NAME} FBS соответствующий склад в основной системе ${getDisplayTypeFromType(INTEGRATION_TYPE_1C)}.`,
    [INTEGRATION_TYPE_MOYSKLAD]: `Ваша основная система ${getDisplayTypeFromType(INTEGRATION_TYPE_MOYSKLAD)}. Чтобы избежать дублирования остатков, укажите для каждого склада ${OZON_SERVICE_NAME} FBS соответствующий склад в основной системе ${getDisplayTypeFromType(INTEGRATION_TYPE_MOYSKLAD)}.`,
};

export const WAREHOUSE_LINKED_CAPTIONS: Partial<Record<SupportedIntegrationTypes, string>> = {
    [INTEGRATION_TYPE_1C]: `Связанный склад в ${getDisplayTypeFromType(INTEGRATION_TYPE_1C)}`,
    [INTEGRATION_TYPE_MOYSKLAD]: `Связанный склад в ${getDisplayTypeFromType(INTEGRATION_TYPE_MOYSKLAD)}`,
};

export const MAIN_WAREHOUSE_CAPTIONS: Partial<Record<SupportedIntegrationTypes, string>> = {
    [INTEGRATION_TYPE_1C]: `Склад ${getDisplayTypeFromType(INTEGRATION_TYPE_1C)}`,
    [INTEGRATION_TYPE_MOYSKLAD]: `Склад ${getDisplayTypeFromType(INTEGRATION_TYPE_MOYSKLAD)}`,
};

export const MAIN_WAREHOUSE_ICONS: Partial<Record<SupportedIntegrationTypes, React.ReactNode>> = {
    [INTEGRATION_TYPE_1C]: <Icon1C size="20" />,
    [INTEGRATION_TYPE_MOYSKLAD]: <IconMoySklad size="20" />,
};

export const getWarehouseHeaderCaption = (type?: SupportedIntegrationTypes): string =>
    type ? (WAREHOUSE_HEADER_CAPTIONS[type] ?? '') : '';

export const getWarehouseLinkedCaption = (type?: SupportedIntegrationTypes): string =>
    type ? (WAREHOUSE_LINKED_CAPTIONS[type] ?? '') : '';

export const getMainWarehouseCaption = (type?: SupportedIntegrationTypes): string =>
    type ? (MAIN_WAREHOUSE_CAPTIONS[type] ?? '') : '';

export const getMainWarehouseIcon = (type?: SupportedIntegrationTypes): React.ReactNode =>
    type ? (MAIN_WAREHOUSE_ICONS[type] ?? null) : null;
